import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoService } from '@jsverse/transloco';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
// ================== NgRx Store ==================
import { Store } from '@ngrx/store';
import * as GlobalActions from '../store/global.actions';

@Component({
  selector: 'lib-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss'],
  imports: [CommonModule]
})
export class TopbarComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  isSticky = true;
  isOpaque = false;
  isNavigationOpen = false;
  currentLang: string;

  constructor(
    private translocoService: TranslocoService,
    private store: Store,
    private router: Router
  ) {
    this.currentLang = this.translocoService.getActiveLang();
  }

  ngOnInit(): void {
    this.translocoService.setActiveLang(this.currentLang);

    this.translocoService.langChanges$.pipe(takeUntil(this.destroy$)).subscribe((lang: string) => {
      this.currentLang = lang;
      this.store.dispatch(GlobalActions.setLanguage({ language: lang }));
      this.router.navigate([`/${lang}`]);
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  setLanguage(lang: string): void {
    this.translocoService.setActiveLang(lang);
    this.store.dispatch(GlobalActions.setLanguage({ language: lang }));
  }

  navigateToHome() {
    window.location.href = 'https://serkanyarar.dev';
  }

  toggleNavigation(): void {
    this.isNavigationOpen = !this.isNavigationOpen;
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    this.isOpaque = scrollTop > 100;
  }
}
